import { all, call, put, select, take, takeEvery } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  fireToastError,
  fireToastSuccess,
} from '../../actions/toasts/fireToast'
import { signOffFromSession } from '../../actions/userAccount/authorize/unauthorize'
import {
  IUpdatePassword,
  passwordRejected,
  passwordUpdated,
} from '../../actions/userAccount/user/updatePassword'
import i18n from '../../i18n'
import { updatePassword as updatePasswordModel } from '../../models/User'
import {
  UpdatePasswordActions,
  UserAccountActions,
} from '../../reducers/userAccount/actionNames'
import {
  getUserEmail,
  getUsername,
} from '../../reducers/userAccount/selectors/userAccount'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import authRequest from '../../models/User/authorize'
import fetchFactory from '../../models/fetch'
import deleteUserAccount from '../../models/User/deleteUserAccount'
import { Mixpanel } from '../../utils/Mixpanel'

function* updatePassword(action: IUpdatePassword) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdatePassword)
    const [service, user] = yield all([
      take(actionNames.output),
      select(getUserEmail),
      put(
        callFetch(actionNames.input, actionNames.output, updatePasswordModel),
      ),
    ])

    yield call(service.service, user.email, action.password)
    yield put(passwordUpdated())
  } catch (e) {
    yield put(passwordRejected())
  }
}

function* onPasswordUpdated() {
  yield put(fireToastSuccess(i18n.t('BBO_936_password_updated')))
  yield put(signOffFromSession())
}

function* onPasswordRejected() {
  yield fireToastError(i18n.t('z936_new_password_rejected'))
}

function* deleteAccount(action) {
  try {
    if (!action.payload.password) {
      throw new Error('Password is required')
    }
    const fetchModel = authRequest({
      fetch: fetchFactory('').fetch,
    })

    const username = yield select(getUsername)

    yield call(fetchModel, username, action.payload.password)

    const actionNames = fetchActionsName(ActionNames.DeleteUser)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, deleteUserAccount)),
    ])

    yield call(service)

    yield put(
      fireToastSuccess(i18n.t('BED_4400_account_deletion_confirmation_prompt')),
    )

    Mixpanel.track('Account Deletion By User', {
      Comment: action.payload.description,
      'Competition Comment': action.payload.competitionApp,
      'Reason of deletion': action.payload.reason,
    })

    yield put(signOffFromSession())
  } catch (e) {
    console.log(e)
    yield put({ type: UserAccountActions.ToggleDeleteError, payload: true })
  }
}

export default function*() {
  yield takeEvery(UpdatePasswordActions.UpdatePassword, updatePassword)
  yield takeEvery(UpdatePasswordActions.PasswordUpdated, onPasswordUpdated)
  yield takeEvery(UpdatePasswordActions.PasswordRejected, onPasswordRejected)
  yield takeEvery(UserAccountActions.TryDeleteAccount, deleteAccount)
}
